import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'antd';
import dynamic from 'next/dynamic';
import less from './ApplicationScenarios.less';
import RealTimeSpeechRecognitionLess from './RealTimeSpeechRecognition.less';
import account from '@/common/account/index';

const Recorder = dynamic(() => import('./Recorder'), { ssr: false });

const RealTimeSpeechRecognition = ({ abilityList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [recordingStatus, setRecordingStatus] = useState(0); // 0未开始，1正在进行，2结束录音，3全部结果都已返回
  const [modName, setModName] = useState('DAHAI-GEN-0-THR');
  const [filterData, setFilterData] = useState(abilityList);
  const CarouselRef = useRef(null);
  const ScenesRef = useRef(null);
  const AudioRef = useRef(null);
  const carouselSettings = {
    swipeToSlide: false,
    swipe: false,
    dots: false,
    touchMove: false
  };

  const changeCurrentIndex = (num) => {
    setCurrentIndex(num);
    CarouselRef.current.goTo(num, true);
    setModName(abilityList[num].modName);
    AudioRef.current.stop();
  };

  const startRecognise = () => {
    const loginEd = account.hasLoggedin();
    if (!loginEd) {
      window.location.href = `/account/login?from=${window.location.pathname}${window.location.search}`;
      return;
    }
    setRecordingStatus(1);
    AudioRef.current.start();
  };

  return (
    <div className={RealTimeSpeechRecognitionLess.realTimeSpeechRecognition}>
      <div
        className={
          less.scenesBox + ' ' + RealTimeSpeechRecognitionLess.scenesBox
        }
        ref={ScenesRef}
      >
        <div className={less.scenesTypesBox}>
          {filterData.map((content) => {
            return (
              <div
                key={content.modName}
                className={
                  less.scenesType +
                  ' ' +
                  (currentIndex === content.inx && less.active)
                }
                onClick={() => changeCurrentIndex(content.inx)}
              >
                {content.title}
                <span className={less.bottomLine} />
              </div>
            );
          })}
        </div>
        <Carousel ref={CarouselRef} {...carouselSettings} effect="fade">
          {filterData.map((content) => {
            return (
              <div key={content.modName}>
                <div className={RealTimeSpeechRecognitionLess.scenesContent}>
                  {content.result}
                </div>
                <p className={RealTimeSpeechRecognitionLess.tip}>
                  当前为<span>{content.title.split('-')[0]}</span>
                  语音识别，适用于<span>{content.applicableScenario}</span>
                </p>
              </div>
            );
          })}
        </Carousel>
      </div>
      <button
        type="button"
        className={
          RealTimeSpeechRecognitionLess.button +
          ' ' +
          (recordingStatus === 1 ? RealTimeSpeechRecognitionLess.hidden : '')
        }
        onClick={() => startRecognise()}
      >
        开始识别
      </button>
      <div
        className={
          RealTimeSpeechRecognitionLess.recording +
          ' ' +
          (recordingStatus !== 1 ? RealTimeSpeechRecognitionLess.hidden : '')
        }
      >
        <Recorder
          recordingStatus={recordingStatus}
          setRecordingStatus={setRecordingStatus}
          setFilterData={setFilterData}
          modName={modName}
          filterData={filterData}
          type={'RealTimeSpeech'}
          recoderRef={AudioRef}
        />
      </div>
    </div>
  );
};

RealTimeSpeechRecognition.propTypes = {
  abilityList: PropTypes.arrayOf(
    PropTypes.shape({
      inx: PropTypes.number,
      title: PropTypes.string,
      result: PropTypes.string,
      modName: PropTypes.string,
      applicableScenario: PropTypes.string
    })
  )
};

export default RealTimeSpeechRecognition;
